import React from 'react';
import PropTypes from 'prop-types';
import ServicesForm from '../../servicesForm/servicesForm';
import withCanModifyBarber from './withCanModifyBarber';

const Services = ({ useShopServices, canModify, barberId }) => (
  <div className="u-mv u-height-510 u-scrollable">
    <fieldset disabled={!canModify}>
      <ServicesForm useShopServices={useShopServices} barberId={barberId} />
    </fieldset>
  </div>
);

Services.propTypes = {
  useShopServices: PropTypes.bool.isRequired,
  canModify: PropTypes.bool.isRequired,
  barberId: PropTypes.string,
};

Services.defaultProps = {
  barberId: null,
};

export default withCanModifyBarber(Services);
